import React from 'react';

export const THEME_STORAGE_KEY = 'schreiberlein_theme_mode';

const ThemeModeContext = React.createContext({
    mode: 'light',
    isDark: false,
    setMode: () => {},
    toggleMode: () => {},
});

const resolveInitialMode = () => {
    if (typeof window === 'undefined') {
        return 'light';
    }
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') {
        return stored;
    }
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    return 'light';
};

export function ThemeModeProvider({ children }) {
    const [mode, setMode] = React.useState(resolveInitialMode);

    React.useEffect(() => {
        localStorage.setItem(THEME_STORAGE_KEY, mode);
    }, [mode]);

    const toggleMode = React.useCallback(() => {
        setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
    }, []);

    const value = React.useMemo(
        () => ({
            mode,
            isDark: mode === 'dark',
            setMode,
            toggleMode,
        }),
        [mode, toggleMode]
    );

    return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
}

export function useThemeMode() {
    return React.useContext(ThemeModeContext);
}
